function Row({ children, className, ...props }) {
	return (
		<tr {...props} className={`main_table_row ${className}`}>
			{children}
		</tr>
	);
}

export default Row;
